import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "./const";

class shiftCreditCardService {
  getEmployeeCreditCard(shiftentityid: number) {
    return axios.get(
      API_URL +
        "employeecreditcard/availableemployees?shiftentityid=" +
        shiftentityid,
      {
        headers: authHeader(),
      }
    );
  }

  saveOrUpdateEmployeeCreditCard(employeeCreditCards: any) {
    console.log(employeeCreditCards);
    return axios.post(
      API_URL + "employeecreditcard/employeetransactions",
      employeeCreditCards,
      { headers: authHeader() }
    );
  }
}

export default new shiftCreditCardService();
